export default __webpack_public_path__ + "static/education-video-cube-38e0a16ce978d12b025480904e325a85.gif";